<template>
  <div id='problem'>
    <h2>Names Scores</h2>
    <a href="https://projecteuler.net/problem=22">https://projecteuler.net/problem=22</a>
    <h3>Thoughts</h3>
    <p>
      Nothing interesting happening here. Every language has sort, and mapping from characters to numbers is trivial.
    </p>
  </div>
</template>

<script>

export default {
  name: 'P022Page',
  components: {
  },
}

</script>

<style scoped>
div#problem {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-flow: column;
  text-align: left;
  font-size: 1.5rem;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25rem;
  max-width: 90ch;
}
</style>
